import React from 'react';
import { Link } from 'react-router-dom';

const ForumDetails: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Forum Details</h6>
                        <p className="text-secondary small">Lets make it open environment to get helped</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/forum"> Forum</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> Forum Details</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                {/* search */}
                <div className="row gx-3 gx-lg-4 align-items-center justify-content-center mb-3 mb-lg-4">
                    <div className="col-12 col-md mb-3 mb-md-0">
                        <div className="input-group rounded">
                            <span className="input-group-text text-theme-1"><i className="bi bi-search"></i></span>
                            <input className="form-control" type="search" placeholder="Search your query here..." />
                        </div>
                    </div>
                    <div className="col-6 col-md-auto d-grid">
                        <button className="btn btn-theme">Ask Query</button>
                    </div>
                    <div className="col-6 col-md-auto d-grid">
                        <button className="btn btn-theme">Write Post</button>
                    </div>
                </div>

                {/* questions and answer*/}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-8 col-lg-9 col-xl-9">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col">
                                        <h6>How to create admin dashboard for Finance Application?</h6>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Asked by</p>
                                        <p className="mb-0">David Warner <small className="text-secondary">1 hr ago</small></p>
                                    </div>
                                    <div className="col-auto text-end">
                                        <p className="small text-secondary mb-0">Modified</p>
                                        <p className="mb-0">8 min ago</p>
                                    </div>
                                </div>
                                <p className="text-secondary">You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                <p>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-red me-1 mt-1">Support</span>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-red me-1 mt-1">Development</span>
                                </p>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-2.jpg" alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-3.jpg" alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-4.jpg" alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary small mb-0">Answers</p>
                                        <h6>9+</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Views</p>
                                        <h6>152</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Watching</p>
                                        <h6>256</h6>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme">Answer</a>
                                    </div>
                                </div>
                                <div className="input-group">
                                    <input type="text" className="form-control border" placeholder="Your comment here..." />
                                    <button className="btn btn-light border" type="button">Comment</button>
                                </div>
                            </div>
                        </div>

                        {/* posted answer */}
                        <h5 className="title">Answers</h5>
                        <div className="card adminuiux-card bg-l-gradient-light theme-green mb-3 mb-lg-4">
                            <div className="card-body">
                                <p><span className="badge badge-lg text-bg-theme-1">Correct Answer</span></p>
                                <p className="text-secondary">I found a solution to your problem. <br />
                                    The installer works fine once I removed it out of my cluttered download folder<br />
                                    I ran various tests and I'm pretty sure that i found the root to the problem.<br />
                                    You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.
                                </p>

                                <div className="row gx-3 align-items-center mt-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src="assets/img/adminuiux/user-1.jpg" alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Answer by</p>
                                        <p className="mb-0">Jack Manelia <small className="text-secondary">30 min ago</small></p>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Mark as Correct</a></li>
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="card-footer border-top">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0 me-auto">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-2.jpg" alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-3.jpg" alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-4.jpg" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-auto"></div>
                                    <div className="col">
                                        <p className="text-secondary small mb-0">Answers</p>
                                        <h6>9+</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Views</p>
                                        <h6>152</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Watching</p>
                                        <h6>256</h6>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme">Answer</a>
                                    </div>
                                </div>
                                <div className="input-group">
                                    <input type="text" className="form-control border" placeholder="Your comment here..." />
                                    <button className="btn btn-light border" type="button">Comment</button>
                                </div>

                                {/* answer comments */}
                                <div className="row gx-3 mt-3">
                                    <a href="" className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle vm shadow-sm">
                                            <img src="assets/img/adminuiux/user-4.jpg" alt="" />
                                        </figure>
                                    </a>
                                    <div className="col">
                                        <p className="mb-1"><a href="">Jack Lee</a> <span className="text-secondary d-inline-block ms-2 small">2 min ago</span></p>
                                        <p>This works for me</p>
                                        <div className="mt-2">
                                            <a className="btn btn-sm btn-link text-theme">
                                                <i className="bi bi-heart vm"></i> Like <small className="ms-2">3</small>
                                            </a>

                                            <a className="btn btn-sm btn-link theme-yellow ms-2">
                                                <i className="bi bi-chat-right-text vm small"></i> Reply <small className="ms-2">5</small>
                                            </a>
                                        </div>

                                        {/* nested post */}
                                        <div className="row gx-3 mt-3">
                                            <a href="" className="col-auto">
                                                <figure className="avatar avatar-40 rounded-circle vm shadow-sm">
                                                    <img src="assets/img/adminuiux/user-2.jpg" alt="" />
                                                </figure>
                                            </a>
                                            <div className="col">
                                                <p className="mb-1"><a href="">Kavyaa Johnson</a> <span className="text-secondary d-inline-block ms-2 small">2 min ago</span></p>
                                                <p>Yes I did it too.</p>
                                                <div className="mt-2">
                                                    <a className="btn btn-sm btn-link text-theme">
                                                        <i className="bi bi-heart vm"></i> Like <small className="ms-2">3</small>
                                                    </a>

                                                    <a className="btn btn-sm btn-link theme-yellow ms-2">
                                                        <i className="bi bi-chat-right-text vm small"></i> Reply <small className="ms-2">5</small>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <p className="text-secondary">I found a solution to your problem. <br />
                                    The installer works fine once I removed it out of my cluttered download folder<br />
                                    I ran various tests and I'm pretty sure that i found the root to the problem.<br />
                                    You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.
                                </p>

                                <div className="row gx-3 align-items-center mt-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src="assets/img/adminuiux/user-1.jpg" alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Answer by</p>
                                        <p className="mb-0">Jack Manelia <small className="text-secondary">30 min ago</small></p>
                                    </div>
                                    <div className="col-auto text-end">
                                        <p className="small text-secondary mb-0">Modified</p>
                                        <p className="mb-0">8 min ago</p>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Mark as Correct</a></li>
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="card-footer border-top">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-2.jpg" alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-3.jpg" alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src="assets/img/adminuiux/user-4.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group">
                                    <input type="text" className="form-control border" placeholder="Your comment here..." />
                                    <button className="btn btn-light border" type="button">Comment</button>
                                </div>
                            </div>
                        </div>

                        {/* advertisement */}
                        <div className="card bg-theme-1 mb-3 mb-lg-4 overflow-hidden">
                            <div className="card-body position-relative">
                                <h3 className="text-theme mb-1">Refer &amp; Earn 20%</h3>
                                <h5 className="fw-medium">Make your wallet even bigger</h5>
                                <p className="opacity-75">Share your referral code to your friends and earn flat 20% amount.</p>
                                <a href="" className="btn btn-light ">Learn more <i className="bi bi-arrow-right"></i></a>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto avatar-group">
                                        <figure className="avatar avatar-40 rounded-circle coverimg overlay-ms-15" data-bs-toggle="tooltip" data-bs-placement="top" title="Shelvey Doe">
                                            <img src="assets/img/adminuiux/user-2.jpg" alt="" />
                                        </figure>
                                        <figure className="avatar avatar-40 rounded-circle coverimg overlay-ms-15" data-bs-toggle="tooltip" data-bs-placement="top" title="Maria Smith">
                                            <img src="assets/img/adminuiux/user-8.jpg" alt="" />
                                        </figure>
                                        <figure className="avatar avatar-40 rounded-circle coverimg overlay-ms-15" data-bs-toggle="tooltip" data-bs-placement="top" title="Steve Branden">
                                            <img src="assets/img/adminuiux/user-4.jpg" alt="" />
                                        </figure>
                                    </div>
                                    <div className="col-auto">
                                        <p className="mb-0">20+ Contacts</p>
                                        <p className="opacity-75 small">Already Refereed</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* post answer */}
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <h6 className="mb-3 mb-lg-4">Your Answer</h6>
                                <textarea className="form-control mb-3"></textarea>
                                <div className="row gx-3 mb-3 mb-lg-4">
                                    <div className="col-auto">
                                        <button className="btn btn-sm btn-outline-theme" type="button"><i className="bi bi-paperclip me-0 me-md-2"></i> <span className="d-none d-md-inline-block">Attachment</span></button>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-sm btn-outline-theme" type="button"><i className="bi bi-link"></i> <span className="d-none d-md-inline-block">Insert Link</span></button>
                                    </div>
                                </div>

                                <div className="row gx-3">
                                    <div className="col">
                                        <button className="btn btn-theme" type="button"><i className="bi bi-send me-2"></i> Send</button>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link theme-red" type="button"><i className="bi bi-trash h4 me-2"></i> Discard</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                        <div className="card bg-l-gradient-light mb-3 mb-lg-4">
                            <div className="card-header border-bottom">
                                <h6>Featured Questions</h6>
                            </div>
                            <div className="card-body p-0">
                                <div className="list-group list-group-flush bg-none">
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">How to become most powerful development partner?</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">The best way to get started with the getDevUIUX</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">I have found egyptian assets, What I should do with it?</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">How long it will take to make world record for traveling?</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action ">I am disabled person by my hands. What is my career options?</Link>
                                </div>
                            </div>
                        </div>
                        {/* advertisement */}
                        <p className="text-secondary text-center small">Advertisement</p>
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="row gx-0">
                                <div className="col-6 bg-theme-1 text-white text-center p-3 z-index-1">
                                    <div className="position-relative">
                                        <h4 className="mb-2">15% OFF</h4>
                                        <p className="opacity-75 small mb-3">Price including with our launch offer get 5% Extra</p>
                                        <button className="copy-text btn btn-sm btn-rounded btn-outline-dashed text-white border-white">GOREELLAUNCH</button>
                                    </div>
                                </div>
                                <div className="col-6 position-relative">
                                    <figure className="coverimg position-absolute w-100 h-100 start-0 top-0 m-0">
                                        <img src={asset("../../assets/img/adminuiux/image-1.jpg")} className="mw-100" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <h6 className="mb-3 mb-lg-4">Trending Tags</h6>
                        <div>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Android</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">iOS</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Windows11</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Fluent ui</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Win UI</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Template</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Dashboard</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Bootstrap</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Angular admin</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Free Dashboard</a>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default ForumDetails;
